import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISubjectInfo } from 'src/types/SubjectInfo';

const initialState: ISubjectInfo = {
  subject_id: '',
  visit_type: '',
  visit_id: '',
  selected_crf: '',
  selectedSubject: '',
  selected_prescreen_id: '',
  patient_identifier: '',
  ehr_facility_id: ''
};

export const selectedSubjectInfo = createSlice({
  name: 'selectedSubjectInfo',
  initialState,
  reducers: {
    clearSubjectInfo: state => {
      state.subject_id = '';
      state.visit_type = '';
      state.visit_id = '';
      state.selected_crf = '';
      state.selected_prescreen_id = '';
      state.patient_identifier = '';
      state.ehr_facility_id = '';
    },
    setSubjectInfo: (state, action: PayloadAction<any>) => {
      state.subject_id = action.payload.subject_id;
      state.visit_type = action.payload.visit_type;
      state.visit_id = action.payload.visit_id;
      state.selected_crf = action.payload.selected_crf;
      state.selected_prescreen_id = action.payload.prescreening_id;
      state.patient_identifier = action.payload.patient_identifier;
      state.ehr_facility_id = action.payload.ehr_facility_id;
    },
    setSelectedSubject: (state, action: PayloadAction<any>) => {
      state.selectedSubject = action.payload;
    }
  }
});

export const { clearSubjectInfo, setSubjectInfo, setSelectedSubject } = selectedSubjectInfo.actions;
